import React, { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import CryptoGuide from "../components/CryptoGuide";
import Footer from "../components/Footer";
import PurchaseModal from "../components/PurchaseModal";

const Home = () => {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState(null);

  const openBuy = (selected = null) => {
    setPlan(selected);
    setOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#0a101e] text-slate-100">
      <Header onBuy={() => openBuy(null)} />
      <Hero onBuy={() => openBuy(null)} />
      <Pricing onChoose={(p) => openBuy(p)} />
      <FAQ />
      <CryptoGuide />
      <Footer />
      <PurchaseModal open={open} onOpenChange={setOpen} initialPlan={plan} />
    </div>
  );
};

export default Home;
